<template>
    <el-pagination
      style="text-align:right"
      @size-change="sizeChange"
      @current-change="pageChange"
      background
      layout="total,prev, pager, next"
      :total="total"
      :current-page="pageCount"
      :page-size="pageSize"
    ></el-pagination>
</template>
<script>
  export default{
    props:{
      total:{
        type:[Number,String],
        default:0
      },
      pageCount:{
        type:[Number,String],
        default:1
      },
      pageSize:{
        type:[Number,String],
        default:20
      }
    },
    methods:{
      sizeChange(size){
        this.$emit('sizeChange',size)
      },
      pageChange(page){
        this.$emit('pageChange',page)
      }
    }
  }
</script>